import { useState, useContext } from 'react';
import { Tooltip } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import DialogField from '../../common/DialogField';
import useGlynt from '../../hooks/useGlynt';
import { AppContext } from '../../../App';
import { AxiosError } from 'axios';
import { ITrainingSet } from '../../../types/my-types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTrainingSetUpdate } from '../../hooks/useTrainingSetUpdate';

import useTrainingSets from '../../hooks/useTrainingSets';

interface ITrainingSetRenameProps {
  trainingSet: ITrainingSet;
}

function TrainingSetRename({ trainingSet }: ITrainingSetRenameProps) {
  const { setToast } = useContext(AppContext);
  const [open, setOpen] = useState(false);
  const [apiDuplicated, setApiDuplicated] = useState(false);
  const [value, setValue] = useState('');
  const [apiError, setApiError] = useState('');
  const glynt = useGlynt();
  const client = useQueryClient();

  const renameTrainingSet = useTrainingSetUpdate({
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: ['trainingSet']
      });
      client.invalidateQueries({
        queryKey: ['trainingSets']
      });
      setToast({
        variant: 'success',
        open: true,
        message: 'Training set renamed successfully.',
      });
      setOpen(false);
    },

    onError: (error: AxiosError) => {
      let message =
        error.message || 'Sorry, failed to rename. Please make sure that the label is unique.';
      setApiError(`Sorry, failed to rename. ${error}`);
      setToast({
        variant: 'error',
        open: true,
        message: 'Failed to rename training set.',
      });
    },
  });

  const trainingSets = useTrainingSets(true, true);

  let names: string[] = [];
  if (trainingSets) {
    names = trainingSets.map((e: ITrainingSet) => e.label);
  }

  const handleSubmit = () => {
    if (value.length > 0 && value !== trainingSet.label) {
      renameTrainingSet.mutate({ trainingSetId: trainingSet.id, data: { label: value } });
    } else {
      setOpen(false);
    }
  };

  return (
    <>
      <Tooltip placement="top" title="Rename Training Set">
        <CreateIcon
          style={{
            color: '#65BBA9',
            // cursor: isLoading ? 'not-allowed' : 'pointer',
            cursor: 'pointer',
            fontSize: '17px',
            marginLeft: '10px',
          }}
          data-cy="btn-rename-ts"
          onClick={() => {
            setOpen(true);
            setApiError('');
          }}
          // disabled={isLoading}
        />
      </Tooltip>

      <DialogField
        title="Rename Training Set"
        placeholder="Training Set Name"
        open={open}
        setOpen={setOpen}
        initValue={trainingSet.label}
        apiDuplicated={apiDuplicated}
        setApiDuplicated={setApiDuplicated}
        names={names}
        checkApiDuplicated={setValue}
        apiError={apiError}
        setApiError={setApiError}
        handleSubmit={handleSubmit}
        cypressId={'input-rename-training-set'}
        width="600px"
      />
    </>
  );
}

export default TrainingSetRename;
